import axios from "axios";
import { tmsApi } from "../api";

export const getAllDriverPayouts = async (data, page = 0, size = 10, sort = 'id,desc') => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(
                tmsApi + `v1/entities/driverpayout/findAll?page=${page}&size=${size}&sort=${sort}`,
                data,
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createDriverPayout = async (data) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/driverpayout`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const updateDriverPayout = async (id, data) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(tmsApi + `v1/entities/driverpayout/${id}`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const deleteDriverPayout = async (id) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .delete(tmsApi + `v1/entities/driverpayout/${id}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

// --- Package Payout Mappings ---

export const getPackagePayoutMappings = async (data, page = 0, size = 10, sort = 'id,desc') => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/packagesdriverpayout/findAll?page=${page}&size=${size}&sort=${sort}`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createPackagePayoutMapping = async (data) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/packagesdriverpayout`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const updatePackagePayoutMapping = async (id, data) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .put(tmsApi + `v1/entities/packagesdriverpayout/${id}`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const deletePackagePayoutMapping = async (id) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .delete(tmsApi + `v1/entities/packagesdriverpayout/${id}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createPackagePayoutMappingBulk = async (data) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/packagesdriverpayout/bulk`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const createPayoutForPackageBulk = async (data) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(tmsApi + `v1/entities/packagesdriverpayout/package/bulk`, data, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getPackageDriverPayoutByPackageId = async (packagesId) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/packagesdriverpayout/package/${packagesId}`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getPackageDriverPayoutByCorporateClientId = async (corporateClientId) => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .post(
                tmsApi + `v1/entities/packagesdriverpayout/findAll?sort=id,desc`,
                { corporateClientId, isPagination: false },
                config
            )
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};

export const getPayoutAllowedCities = async () => {
    const config = {
        headers: {
            token: localStorage.getItem("token"),
            "Access-Control-Allow-Origin": "*"
        },
    };
    try {
        return axios
            .get(tmsApi + `v1/entities/driverpayout/getCities`, config)
            .then((resp) => {
                console.log(resp, "response");
                return resp;
            });
    } catch (error) {
        console.log("error", error);
    }
};
